import React, { useCallback } from "react";

import { v4 as uuidv4 } from "uuid";

import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Button } from "react-bootstrap";

import Selector from "../../../components/selector";

import {
  StyledGrid,
  StyledRow,
  StyledCol,
  StyledBoxAccommodation,
  StyledButtonIconBorder,
} from "../styled";

import { getValuesByNumber } from "../utils";

import { BasicInput } from "./Inputs";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { differenceInDays } from "date-fns";

const getValueFieldAccommodation = (valuesRoom: any) => {
  return valuesRoom.nameAccommodation
    ? `${valuesRoom.nameAccommodation} | ${valuesRoom.mealplan} | ${valuesRoom.condition}`
    : "";
};

const getColHeaderPerson = (configurations: any) => {
  let xs;
  let countFields = 0;
  countFields += configurations?.maxAdults > 0 ? 1 : 0;
  countFields += configurations?.maxTeenagers > 0 ? 1 : 0;
  countFields += configurations?.maxChildren > 0 ? 1 : 0;
  countFields += configurations?.maxBabies > 0 ? 1 : 0;
  switch (countFields) {
    case 1:
      xs = 1;
      break;
    case 2:
      xs = 2;
      break;
    case 3:
      xs = 2;
      break;
    case 4:
      xs = 3;
      break;

    default:
      break;
  }
  return xs;
};

const getColRowFields = (configurations: any) => {
  let xs;
  let countFields = 0;
  countFields += configurations?.maxAdults > 0 ? 1 : 0;
  countFields += configurations?.maxTeenagers > 0 ? 1 : 0;
  countFields += configurations?.maxChildren > 0 ? 1 : 0;
  countFields += configurations?.maxBabies > 0 ? 1 : 0;
  switch (countFields) {
    case 1:
      xs = 12;
      break;
    case 2:
      xs = 6;
      break;
    case 3:
      xs = 4;
      break;
    case 4:
      xs = 3;
      break;

    default:
      break;
  }
  return xs;
};

const messages = defineMessages({
  formAccommodationAdults: {
    id: "quotation.formAccommodation.adults",
    defaultMessage: "adultos",
  },
  formAccommodationJuniors: {
    id: "quotation.formAccommodation.juniors",
    defaultMessage: "juniors",
  },
  formAccommodationChildren: {
    id: "quotation.formAccommodation.children",
    defaultMessage: "niños",
  },
  formAccommodationBabies: {
    id: "quotation.formAccommodation.babies",
    defaultMessage: "bebes",
  },
  formAccommodationUds: {
    id: "quotation.formAccommodation.uds",
    defaultMessage: "Uds",
  },
  formAccommodationRoom: {
    id: "quotation.formAccommodation.room",
    defaultMessage: "Alojamiento | Pension | Condición",
  },

  formAccommodationHab: {
    id: "quotation.formAccommodation.hab",
    defaultMessage: "/ hab",
  },
  formAccommodationHourDay: {
    id: "quotation.formAccommodation.hourDay",
    defaultMessage: "h/día",
  },
  formAccommodationExtras: {
    id: "quotation.formAccommodation.extras",
    defaultMessage: "Extras",
  },
  formAccommodationTotalOccupants: {
    id: "quotation.formAccommodation.totalOccupants",
    defaultMessage: "Total ocupantes",
  },
  formAccommodationAddRoom: {
    id: "quotation.formAccommodation.addRoom",
    defaultMessage: "Añadir habitación",
  },
});

const Header = ({ tab }: any) => {
  return (
    <StyledRow>
      <StyledCol xs={getColHeaderPerson(tab?.configurations)}>
        <StyledGrid>
          <StyledRow>
            {tab?.configurations?.maxAdults > 0 && (
              <StyledCol xs={getColRowFields(tab?.configurations)}>
                <FormattedMessage {...messages.formAccommodationAdults} />
              </StyledCol>
            )}

            {tab?.configurations?.maxTeenagers > 0 && (
              <StyledCol xs={getColRowFields(tab?.configurations)}>
                <FormattedMessage {...messages.formAccommodationJuniors} />
              </StyledCol>
            )}
            {tab?.configurations?.maxChildren > 0 && (
              <StyledCol xs={getColRowFields(tab?.configurations)}>
                <FormattedMessage {...messages.formAccommodationChildren} />
              </StyledCol>
            )}
            {tab?.configurations?.maxBabies > 0 && (
              <StyledCol xs={getColRowFields(tab?.configurations)}>
                <FormattedMessage {...messages.formAccommodationBabies} />
              </StyledCol>
            )}
          </StyledRow>
        </StyledGrid>
      </StyledCol>

      <StyledCol xs={4}>
        <StyledGrid>
          <StyledRow>
            <StyledCol xs={2}>
              <FormattedMessage {...messages.formAccommodationUds} />
            </StyledCol>
            <StyledCol xs={9}>
              <FormattedMessage {...messages.formAccommodationRoom} />
            </StyledCol>
            <StyledCol xs={1}></StyledCol>
          </StyledRow>
        </StyledGrid>
      </StyledCol>

      <StyledCol xs={5}>
        <StyledGrid>
          <StyledRow>
            <StyledCol xs={2}>
              <span>
                {tab?.currency?.label}
                {tab?.currency?.value !== tab?.configurations?.currencyExchange?.currencyBase &&
                  `*`}
              </span>
            </StyledCol>
            <StyledCol xs={2}>
              <span>
                {tab?.currency?.label}
                {tab?.currency?.value !== tab?.configurations?.currencyExchange?.currencyBase &&
                  `*`}
                <FormattedMessage {...messages.formAccommodationHab} />
              </span>
            </StyledCol>
            <StyledCol xs={2}>
              <span>
                {tab?.currency?.label}
                {tab?.currency?.value !== tab?.configurations?.currencyExchange?.currencyBase &&
                  `*`}
                <FormattedMessage {...messages.formAccommodationHourDay} />
              </span>
            </StyledCol>
            <StyledCol xs={3}>
              <FormattedMessage {...messages.formAccommodationExtras} />
            </StyledCol>
            <StyledCol xs={1} />
            <StyledCol xs={1} />
          </StyledRow>
        </StyledGrid>
      </StyledCol>
    </StyledRow>
  );
};

const Body = ({
  tab,
  room,
  changeValue,
  indexRoom,
  searchAccommodations,
  setModalAccommodation,
  getAccommodationValue,
  getExtraValue,
  setModalExtras,
  handleDeleteAccommodations,
}: any) => {
  const intl = useIntl();

  const getValueByDay = useCallback(
    (valueByRoom: number) => {
      const startReservation = new Date(tab.checkIn)
      const endReservation = new Date(tab.checkOut)
      const diffDates = differenceInDays(endReservation,startReservation);
      return (valueByRoom / diffDates || 0).toFixed(2);
    },
    [tab.checkIn, tab.checkOut]
  );

  return (
    <div>
      <StyledRow paddingTop={"4px"}>
        <StyledCol xs={getColHeaderPerson(tab?.configurations)}>
          <StyledGrid>
            <StyledRow>
              {tab?.configurations?.maxAdults > 0 && (
                <StyledCol xs={getColRowFields(tab?.configurations)} padding={"0px 4px !important"}>
                  <div style={{ display: "block", width: "100%" }}>
                    <Selector
                      options={getValuesByNumber(tab?.configurations?.maxAdults || 0)}
                      value={room.adults}
                      onChange={(selectedOption: any) =>
                        changeValue("accommodations.adults", selectedOption, indexRoom)
                      }
                      placeholder={"-"}
                    />
                  </div>
                </StyledCol>
              )}

              {tab?.configurations?.maxTeenagers > 0 && (
                <StyledCol xs={getColRowFields(tab?.configurations)} padding={"0px 4px !important"}>
                  <div style={{ display: "block", width: "100%" }}>
                    <Selector
                      options={getValuesByNumber(tab?.configurations?.maxTeenagers || 0)}
                      value={room.juniors}
                      onChange={(selectedOption: any) =>
                        changeValue("accommodations.juniors", selectedOption, indexRoom)
                      }
                      placeholder={"-"}
                    />
                  </div>
                </StyledCol>
              )}

              {tab?.configurations?.maxChildren > 0 && (
                <StyledCol xs={getColRowFields(tab?.configurations)} padding={"0px 4px !important"}>
                  <div style={{ display: "block", width: "100%" }}>
                    <Selector
                      options={getValuesByNumber(tab?.configurations?.maxChildren || 0)}
                      value={room.childrens}
                      onChange={(selectedOption: any) =>
                        changeValue("accommodations.childrens", selectedOption, indexRoom)
                      }
                      placeholder={"-"}
                    />
                  </div>
                </StyledCol>
              )}

              {tab?.configurations?.maxBabies > 0 && (
                <StyledCol xs={getColRowFields(tab?.configurations)} padding={"0px 4px !important"}>
                  <div style={{ display: "block", width: "100%" }}>
                    <Selector
                      options={getValuesByNumber(tab?.configurations?.maxBabies)}
                      value={room.babies}
                      onChange={(selectedOption: any) =>
                        changeValue("accommodations.babies", selectedOption, indexRoom)
                      }
                      placeholder={"-"}
                    />
                  </div>
                </StyledCol>
              )}
            </StyledRow>
          </StyledGrid>
        </StyledCol>

        <StyledCol xs={4}>
          <StyledGrid>
            <StyledRow>
              <StyledCol xs={2}>
                <BasicInput id={""} label={""} readOnly value={room?.rooms?.value || 0} />
              </StyledCol>
              <StyledCol xs={9}>
                <div style={{ display: "block", width: "100%" }}>
                  <StyledBoxAccommodation>
                    {getValueFieldAccommodation(tab?.accommodations?.[indexRoom])}
                  </StyledBoxAccommodation>
                </div>
              </StyledCol>
              <StyledCol xs={1}>
                <StyledButtonIconBorder
                  variant="outline-primary"
                  onClick={() => {
                    searchAccommodations(indexRoom);
                    setModalAccommodation(true);
                  }}>
                  <FontAwesomeIcon icon={faPencilAlt} />
                </StyledButtonIconBorder>
              </StyledCol>
            </StyledRow>
          </StyledGrid>
        </StyledCol>

        <StyledCol xs={5}>
          <StyledGrid>
            <StyledRow>
              <StyledCol xs={2}>
                <BasicInput
                  id={""}
                  label={""}
                  disabled
                  value={getAccommodationValue(indexRoom).toFixed(2)}
                />
              </StyledCol>

              <StyledCol xs={2}>
                <BasicInput
                  id={""}
                  label={""}
                  disabled
                  value={(getAccommodationValue(indexRoom) / (room?.rooms?.value || 1)).toFixed(2)}
                />
              </StyledCol>
              <StyledCol xs={2}>
                <BasicInput
                  id={""}
                  label={""}
                  disabled
                  value={getValueByDay(getAccommodationValue(indexRoom) / (room?.rooms?.value || 1))}
                />
              </StyledCol>
              <StyledCol xs={3}>
                <BasicInput
                  id={""}
                  label={""}
                  disabled
                  value={getExtraValue(indexRoom).toFixed(2)}
                />
              </StyledCol>
              <StyledCol xs={1}>
                <StyledButtonIconBorder
                  variant="outline-primary"
                  onClick={() => {
                    setModalExtras(indexRoom);
                  }}>
                  <FontAwesomeIcon icon={faPencilAlt} />
                </StyledButtonIconBorder>
              </StyledCol>
              {(tab.accommodations || []).length > 1 && (
                <StyledCol xs={1}>
                  <svg
                    onClick={() => {
                      handleDeleteAccommodations(indexRoom);
                    }}
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <rect width="21" height="21" rx="10.5" fill="#FF6136" />
                    <path
                      d="M15.6023 13.2275C15.7992 13.4244 15.7992 13.7443 15.6023 13.9412L13.9412 15.6023C13.7443 15.7992 13.4244 15.7992 13.2275 15.6023L10.5 12.8502L7.77246 15.6023C7.57559 15.7992 7.25566 15.7992 7.05879 15.6023L5.39766 13.9412C5.20078 13.7443 5.20078 13.4244 5.39766 13.2275L8.1498 10.5L5.39766 7.77246C5.20078 7.57559 5.20078 7.25566 5.39766 7.05879L7.05879 5.39766C7.25566 5.20078 7.57559 5.20078 7.77246 5.39766L10.5 8.1498L13.2275 5.39766C13.4244 5.20078 13.7443 5.20078 13.9412 5.39766L15.6023 7.05879C15.7992 7.25566 15.7992 7.57559 15.6023 7.77246L12.8502 10.5L15.6023 13.2275Z"
                      fill="white"
                    />
                  </svg>
                </StyledCol>
              )}
            </StyledRow>
          </StyledGrid>
        </StyledCol>
      </StyledRow>

      <StyledRow style={{ paddingLeft: "4px", paddingTop: "8px", paddingBottom: "8px" }}>
        <StyledCol xs={12}>
          <span>
            {`${intl.formatMessage(messages.formAccommodationTotalOccupants)} ${
              tab?.configurations?.maxAdults
                ? `${room?.adults?.value || 0} ${intl.formatMessage(
                    messages.formAccommodationAdults
                  )}`
                : ""
            }
                      ${
                        tab?.configurations?.maxTeenager
                          ? ` ${room?.juniors?.value || 0} ${intl.formatMessage(
                              messages.formAccommodationJuniors
                            )}`
                          : ""
                      }

                      ${
                        tab?.configurations?.maxChildren
                          ? ` ${room?.childrens?.value || 0} ${intl.formatMessage(
                              messages.formAccommodationChildren
                            )}`
                          : ""
                      }

                      ${
                        tab?.configurations?.maxBabies
                          ? ` ${room?.babies?.value || 0} ${intl.formatMessage(
                              messages.formAccommodationBabies
                            )}`
                          : ""
                      }
                    `}
          </span>
        </StyledCol>
      </StyledRow>
    </div>
  );
};
export const FormAccommodations = ({
  tab,
  changeValue,
  searchAccommodations,
  setModalAccommodation,
  getAccommodationValue,
  setModalExtras,
  handleDeleteAccommodations,
  getExtraValue,
}: any) => {
  return (
    <StyledGrid padding={"20px"}>
      {(tab.accommodations || []).map((room: any, indexRoom: number) => (
        <React.Fragment key={room.id}>
          <Header tab={tab} />
          <Body
            tab={tab}
            room={room}
            changeValue={changeValue}
            indexRoom={indexRoom}
            searchAccommodations={searchAccommodations}
            setModalAccommodation={setModalAccommodation}
            getAccommodationValue={getAccommodationValue}
            getExtraValue={getExtraValue}
            setModalExtras={setModalExtras}
            handleDeleteAccommodations={handleDeleteAccommodations}
          />
        </React.Fragment>
      ))}

      <StyledRow style={{ paddingLeft: "4px", paddingTop: "16px" }}>
        <StyledCol xs={2}>
          <Button
            onClick={() => {
              changeValue("accommodations", [
                ...tab.accommodations,
                {
                  id: uuidv4(),
                  adults: 0,
                  juniors: 0,
                  childrens: 0,
                  babies: 0,
                  units: 0,
                  room: {},
                  rooms: {},
                },
              ]);
            }}>
            <FormattedMessage {...messages.formAccommodationAddRoom} />
          </Button>
        </StyledCol>
      </StyledRow>
    </StyledGrid>
  );
};
